//z-index
export const zIndexNavbar = 10;
export const zIndexModal = 1000;
export const zIndexLoading = 10000;

//font-color

//background-color
const formatFromElastic = (data) => {
  const format = {
    _id: data.id,
    color: {
      _id: data.color,
      color_th: data.color_th,
      color_en: data.color_en,
    },
    name: data.name,
    texture_type: {
      _id: data.texture,
      type_th: data.texture_th,
      type_en: data.texture_en,
    },
    is_instock: data.is_instock,
    stock_count: data?.stock_count,
    stock_date: data?.stock_date,
    view_count: data.view_count,
    group_price: {
      unit_price: {
        unit_th: data.unit_price_th,
        unit_en: data.unit_price_en,
      },
      price: data.price,
      special_price: data.special_price,
      start_price: data.start_price,
      is_start_price: data.is_start_price,
      install_price: data.install_price || 0,
      sample_price: data.sample_price || 0,
      price_per_sq: data.price_per_sq || 0,
    },
    reduce_percent: data.reduce_percent,
    size: {
      calculate_size: data.calculate_size || null,
      width: data.width,
      height: data.height,
      thickness: data.thickness,
      quantity: data.quantity,
      unit_width: {
        unit_th: data.unit_width_th,
        unit_en: data.unit_width_en,
      },
      unit_height: {
        unit_th: data.unit_height_th,
        unit_en: data.unit_height_en,
      },
      unit_thickness: {
        unit_th: data.unit_thickness_th,
        unit_en: data.unit_thickness_en,
      },
      capacity_size: data.capacity_size,
      unit_capacity: {
        unit_th: data.unit_capacity_th,
        unit_en: data.unit_capacity_en,
      },
    },
    group_image: {
      product_full_image: data.product_full_image,
      product_closeup_image: data.product_image,
      product_display_image: data.display_img,
    },
    product: {
      item_code: data.item_code,
      item_name: data.item_name,
      _id: data.product_id,
      is_deal: data.is_deal,

      status: data.status,
      category: {
        _id: data.categories,
        cate_en: data.categories_en,
        cate_th: data.categories_th,
      },
      pattern: {
        _id: data.pattern,
        pattern_en: data.pattern_en,
        pattern_th: data.pattern_th,
      },
      description: data.description,
      user: {
        _id: data.user_id,
        seller: {
          _id: data.seller_id,
          company_name: data.company_name,
          profile_image: data.profile_image,
          pay_type: data.pay_type,
          is_sell: data.is_sell,
        },
      },
      brand: {
        _id: data.brand_id,
        name: data.brand,
      },
      product_types: data.product_type.split(",").map((el, index) => {
        return {
          _id: el,
          type_th: data.product_type_th.split(",")[index],
          type_en: data.product_type_en.split(",")[index],
        };
      }),
      suitable_areas: data.area.split(",").map((el, index) => {
        return {
          _id: el,
          area_th: data.area_th.split(",")[index],
          area_en: data.area_en.split(",")[index],
        };
      }),
      hashtags: data.hashtag.split(",").map((el) => {
        return {
          name: el,
        };
      }),
    },
  };
  return format;
};

const convertIntToNumber = (int) => new Intl.NumberFormat().format(int);

const convertIntToCurrency = (int, isDecimal = true) => {
  const numericValue =
    typeof int === "string" ? Number(int.replace(/,/g, "")) : int;

  const convertFormat = (Math.round(numericValue * 100) / 100).toLocaleString();
  const currency = `${convertFormat.split(".")[0]}.${
    (Math.round(numericValue * 100) / 100).toFixed(2).split(".")[1]
  }`;
  return isDecimal ? currency : currency.split(".").shift();
};

const currencyToNumber = (currency) => {
  if (currency) {
    return Number(currency.toString().replace(/,/g, ""));
  }
  return 0;
};

const convertPrice = (price) =>
  Intl.NumberFormat("th-TH", {
    style: "currency",
    currency: "THB",
  }).format(price);

const loading = (display = false) => {
  let loading = document.getElementById("loading-full");
  if (display) loading.style.display = "block";
  else loading.style.display = "none";
};

const modalAlert = ({
  show = false,
  close = false,
  type = "success",
  desc = "",
  sizeSmall = false,
}) => {
  let modalAlert = document.getElementsByClassName("modal-alert");
  let modalContent = document.getElementsByClassName("modal-alert-content");
  let iconType = document.getElementsByClassName("icon-type-modal");
  let inner = document.getElementsByClassName("title-alert-modal");
  if (show) {
    modalAlert[0].classList.add("show");
    modalContent[0].classList.add("show");
  }

  if (close) modalAlert[0].classList.remove("show");

  if (type) {
    if (type === "success") {
      iconType[0].classList.add("success");
    } else if (type === "fail") {
      iconType[0].classList.add("fail");
    }
  }

  if (desc) {
    inner[0].innerHTML = desc;
    inner[0].classList.add(type);
  }
};

const checkNotEmpty = (param) => {
  return (
    param !== undefined &&
    param !== null &&
    (!Array.isArray(param) || (Array.isArray(param) && param.length !== 0)) &&
    (!(typeof param === "string") ||
      (typeof param === "string" && param !== "")) &&
    (!(typeof param === "object") ||
      (typeof param === "object" && Object.keys(param).length !== 0))
  );
};

const replaceProductUrl = (param) => {
  return param.split("=").length > 1
    ? "/product/" +
        param
          .split("=")[0]
          .replace("/", "-")
          .replace(".", "-")
          .replace("=", "-") +
        "=" +
        param.split("=")[param.split("=").length - 1]
    : "/product/" +
        param
          .split("=")[0]
          .replace("/", "-")
          .replace(".", "-")
          .replace("=", "-");
};

const numberWithCommas = (num) => {
  return Math.round(num).toLocaleString();
};

/**
 *
 * @param {string} imageUrl
 * @param {string} fileType - png, jpg, pdf etc. default png
 */
const downloadImage = async (imageUrl, fileType = "png") => {
  let nameIndex = imageUrl.lastIndexOf("/");
  let imageName = imageUrl.substring(nameIndex + 1);
  let newImageName =
    imageName.split(".").length > 1 ? imageName : `${imageName}.${fileType}`;

  await fetch(imageUrl + "?v=" + new Date().getTime())
    .then((response) => response.blob())
    .then((blob) => {
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = newImageName;
      a.click();
    })
    .catch((error) => {
      console.error("Error downloading image:", error);
      window.open(`${imageUrl}`, "_blank");
    });
};

const formatPhoneNumber = (phoneNumber) => {
  // Convert the input to a string and remove any non-digit characters
  const cleaned = String(phoneNumber).replace(/\D/g, "");

  // Match exactly 9 digits: three groups of three digits each
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{3})$/);

  if (match) {
    // Format the number as "123-456-789"
    return `${match[1]}-${match[2]}-${match[3]}`;
  }

  // If the input does not have exactly 9 digits, return null or handle it accordingly
  return null;
};

export {
  convertIntToNumber,
  convertIntToCurrency,
  convertPrice,
  modalAlert,
  loading,
  formatFromElastic,
  checkNotEmpty,
  replaceProductUrl,
  downloadImage,
  numberWithCommas,
  formatPhoneNumber,
  currencyToNumber,
};

// const convertIntToNumber = (int) => parseInt(int)

// const convertIntToCurrency = (int) => {
//   const currency = parseFloat(int).toFixed(2)
//   return currency
// }

// export { convertIntToNumber, convertIntToCurrency }
